




























import {Component, Vue} from 'vue-property-decorator'
import {appModule} from '@/store/module/AppModule'
import SidebarItem from './SidebarItem.vue'
import variables from '@/style/_variables.scss'
import {RouterOptions} from "vue-router/types/router";

@Component({
    components: {
        SidebarItem
    }
})
export default class SideBar extends Vue {

    get routes() {
        return (this.$router as unknown as { options: RouterOptions }).options.routes
    }

    get sidebar() {
        return appModule.sidebar
    }

    get variables() {
        return variables
    }

    get activeMenu() {
        const route = this.$route
        const {meta, path} = route
        // if set path, the sidebar will highlight the path you set
        if (meta.activeMenu) {
            return meta.activeMenu
        }
        return path
    }

    get isCollapse() {
        return !this.sidebar.opened
    }
}
